import { BuilderElement, ElementType, GlobalConfig } from "@/types/builder";
import { Children } from "react";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const template1UpsellGlobalConfig: GlobalConfig = {
  typography: [
    {
      name: "Default",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    {
      name: "Heading-1",
      fontFamily: "Inter",
      fontSize: "40px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Heading-2",
      fontFamily: "Inter",
      fontSize: "28px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Body",
      fontFamily: "Inter",
      fontSize: "18px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    {
      name: "Button",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "700",
      fontStyle: "normal",
    },
  ],
  colors: {
    background: "#F3F6FF",
    forground: "#FFFFFF",
    primary: "#A44CF5",
    secondary: "#317CF7",
    tertiary: "#333333",
    quaternary: "#1a1a1a",
    link: "#A44CF5",
    activeLink: "#1D4ED8",
  },
  breakpoints: {
    mobileMax: 640,
    tabletMin: 641,
    tabletMax: 1024,
    desktopMin: 1025,
  },
};
const headerAlertMsgContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    width: "100%",
    height: "92px",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: "url('/fortigold/headerbackground.svg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    padding: 0,
    margin: 0,
  },
  children: [
    {
      id: generateId(),
      type: "text" as ElementType,
      content: "SPECIAL OFFER ENDS IN: XX:21 - BUY NOW",
      styles: {
        color: "quaternary",
        fontFamily: "SF Pro Display",
        fontSize: "30px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "100%",
        textAlign: "center",
        width: "100%",
        letterSpacing: 0,
        zIndex: 1,
      },
    },
  ],
});
const createUpsellHeaderSectionContainer = (globalConfig) => ({
  id: generateId(),
  type: "container",
  styles: {
    padding: "135px 0",
    fontFamily: "SF Pro Display, sans-serif",
    backgroundImage:
      "linear-gradient(89deg, #869c2d 0%, primary 60%, #01432A 100%)",
    width: "100%",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "80px 0",
    },
    mobile: {
      padding: "40px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "logo",
      styles: {
        maxWidth: "336px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "55px",
      },
      responsiveStyles: {
        tablet: {
          maxWidth: "283px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "image",
          src: "/fortigold/logo-gold.webp",
          alt: "Fortigold Logo",
          styles: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "text",
      content: "CONGRATULATIONS!",
      styles: {
        color: "background",
        fontSize: "58.3px",
        fontFamily: "SF Pro Display",
        fontWeight: 700,
        lineHeight: "120%",
        textAlign: "center",
        marginBottom: "12px",
        textTransform: "uppercase",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "36px",
        },
        mobile: {
          fontSize: "28px",
        },
      },
    },
    {
      id: generateId(),
      type: "text",
      content: "YOU HAVE UNLOCKED A BONUS OFFER",
      styles: {
        color: "background",
        fontSize: "58.3px",
        fontWeight: 700,
        lineHeight: "120%",
        textAlign: "center",
        marginBottom: "55px",
        textTransform: "uppercase",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "28px",
        },
        mobile: {
          fontSize: "20px",
        },
      },
    },
    {
      id: generateId(),
      type: "text",
      content:
        "DO NOT CLOSE THIS PAGE! IT MAY CAUSE AN ERROR IN YOUR CONFIRMATION!",
      styles: {
        color: "background",
        fontSize: "27.3px",
        fontWeight: 400,
        lineHeight: "120%",
        textAlign: "center",
        marginTop: "12px",
        letterSpacing: "0.5px",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "16px",
        },
        mobile: {
          fontSize: "14px",
        },
      },
    },
  ],
});

// Offer Sub-Header Section
export const template1UpsellOfferSubHeaderSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    backgroundColor: "rgb(242, 242, 243)",
    padding: "50px 0",
    textAlign: "center",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "40px 0",
    },
    mobile: {
      padding: "20px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxWidth: "1364px",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px 0",
        },
        mobile: {
          gap: "20px 0",
        },
      },
      children: [
        // Header Title as flex row for colored and normal text
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            width: "100%",
          },
          responsiveStyles: {
            mobile: {
              flexDirection: "column",
              gap: "0",
            },
          },
          children: [
            {
              id: generateId(),
              type: "text",
              content: "WAIT!",
              styles: {
                color: "#ED1C24",
                fontSize: "64px",
                fontFamily: "SF Pro Display",
                fontStyle: "normal",
                fontWeight: 900,
                lineHeight: "100%",
                textAlign: "center",
                textTransform: "uppercase",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "38px",
                },
                mobile: {
                  fontSize: "20px",
                },
              },
            },
            {
              id: generateId(),
              type: "text",
              content: "Before we ship your order...",
              styles: {
                color: "#231F20",
                fontSize: "64px",
                fontFamily: "SF Pro Display",
                fontStyle: "normal",
                fontWeight: 900,
                lineHeight: "100%",
                textAlign: "center",
                marginBottom: "13px",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "38px",
                },
                mobile: {
                  fontSize: "20px",
                },
              },
            },
          ],
        },
        // Second line of header title
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            width: "100%",
          },
          responsiveStyles: {
            mobile: {
              flexDirection: "column",
              gap: "0",
            },
          },
          children: [
            {
              id: generateId(),
              type: "text",
              content: "unlock FORTIGOLD's full healing power with",
              styles: {
                color: "#231F20",
                fontSize: "64px",
                fontStyle: "normal",
                fontFamily: "SF Pro Display",
                fontWeight: 900,
                lineHeight: "100%",
                textAlign: "center",
                marginBottom: "13px",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "38px",
                },
                mobile: {
                  fontSize: "20px",
                },
              },
            },
            {
              id: generateId(),
              type: "container",
              styles: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                width: "100%",
                marginBottom: "50px",
              },
              children: [
                {
                  id: generateId(),
                  type: "text",
                  content: "this",
                  styles: {
                    color: "#231F20",
                    fontSize: "64px",
                    fontStyle: "normal",
                    fontFamily: "SF Pro Display",
                    fontWeight: 900,
                    lineHeight: "100%",
                    textAlign: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "38px",
                    },
                    mobile: {
                      fontSize: "20px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "text",
                  content: "ONE-TIME",
                  styles: {
                    color: "#F7941D",
                    fontSize: "64px",
                    fontFamily: "SF Pro Display",
                    fontWeight: 900,
                    lineHeight: "100%",
                    textAlign: "center",
                    textTransform: "uppercase",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "38px",
                    },
                    mobile: {
                      fontSize: "20px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "text",
                  content: "offer",
                  styles: {
                    color: "#231F20",
                    fontSize: "64px",
                    fontStyle: "normal",
                    fontFamily: "SF Pro Display",
                    fontWeight: 900,
                    lineHeight: "100%",
                    textAlign: "center",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "38px",
                    },
                    mobile: {
                      fontSize: "20px",
                    },
                  },
                },
              ],
            },
          ],
        },
        // Subtitle
        {
          id: generateId(),
          type: "text",
          content:
            "Your body needs more than 30 days to fully repair your gut and rebuild your energy — this is your chance to lock in long-term transformation at the deepest discount we'll ever offer.",
          styles: {
            fontFamily: "SF Pro Display",
            color: "#231F20",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "100%",
            maxWidth: "1194px",
            textAlign: "center",
          },
          responsiveStyles: {
            tablet: {
              fontSize: "20px",
            },
            mobile: {
              fontSize: "16px",
            },
          },
        },
      ],
    },
  ],
});

// Features Box Section
export const template1UpsellFeaturesBoxSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    padding: "100px 0 0",
    backgroundColor: "background",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "60px 0 30px",
    },
    mobile: {
      padding: "30px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "30px 0",
        maxWidth: "1337px",
      },
      responsiveStyles: {
        mobile: {
          gap: "16px 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container",
          styles: {
            border: "1px solid #808285",
            width: "100%",
            background: "#fff",
            display: "flex",
            flexDirection: "column",
          },
          children: [
            // Feature Header
            {
              id: generateId(),
              type: "container",
              styles: {
                backgroundImage:
                  "linear-gradient(90deg, rgb(134, 156, 45) 10.18%, rgb(0, 87, 63) 42.91%, #00442A 72%, #00442A 80%)",
                padding: "32px 0",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              responsiveStyles: {
                mobile: {
                  padding: "16px 0",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "text",
                  dynamicContentId: "__dynamic__bottle_count__",
                  content:
                    "This is your ONLY chance to secure 3 extra bottles for just $29 each — over 55% OFF.",
                  styles: {
                    maxWidth: "926px",
                    color: "background",
                    textAlign: "center",
                    fontSize: "40px",
                    fontStyle: "normal",
                    fontFamily: "SF Pro Display",
                    fontWeight: 700,
                    lineHeight: "48px",
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: "24px",
                      lineHeight: "28px",
                    },
                  },
                },
              ],
            },
            // Feature Body
            {
              id: generateId(),
              type: "container",
              styles: {
                padding: "40px",
                backgroundColor: "#DBDBDB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                  padding: "20px",
                },
                mobile: {
                  padding: "10px",
                },
              },
              children: [
                // Image
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    flex: "1 1 calc(50% - 16px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  },
                  children: [
                    {
                      dynamicContentId: "__dynamic__bottle_image__",
                      id: generateId(),
                      type: "image",
                      src: "/fortigold/bottles-3.webp",
                      alt: "Fortigold Bottles",
                      styles: {
                        maxWidth: "90%",
                        width: "100%",
                        margin: "0 auto",
                      },
                      responsiveStyles: {
                        mobile: {
                          maxWidth: "100%",
                        },
                      },
                    },
                  ],
                },
                // Content Body
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: "30px 0",
                    flex: "1 1 calc(50% - 16px)",
                  },
                  responsiveStyles: {
                    mobile: {
                      gap: "16px 0",
                    },
                  },
                  children: [
                    // Feature List (as containers)
                    {
                      id: generateId(),
                      type: "container",
                      styles: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        paddingRight: "50px",
                      },
                      responsiveStyles: {
                        mobile: { gap: "16px" },
                      },
                      children: [
                        // 1st item
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "text",
                              content: "🔥",
                              styles: {
                                fontSize: "24px",
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "text",
                              content:
                                "Get 3 More Bottles of FortiGold for Just87Total (Only $29 Each)",
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: 600,
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                          ],
                        },
                        // 2nd item
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "text",
                              content: "✅",
                              styles: {
                                fontSize: "24px",
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "container",
                              styles: {
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "text",
                                  content: "That's",
                                  styles: {
                                    color: "#231F20",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "18px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                                {
                                  id: generateId(),
                                  type: "text",
                                  content: "less than",
                                  styles: {
                                    color: "#231F20",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: 700,
                                    fontStyle2: "italic",
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "18px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                                {
                                  id: generateId(),
                                  type: "text",
                                  content: "half the price of buying later",
                                  styles: {
                                    color: "#231F20",
                                    fontSize: "24px",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    lineHeight: "26px",
                                  },
                                  responsiveStyles: {
                                    mobile: {
                                      fontSize: "18px",
                                      lineHeight: "24px",
                                    },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        // 3rd item
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "text",
                              content: "✅",
                              styles: {
                                fontSize: "24px",
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "text",
                              content: "Ensures a longer, uninterrupted supply",
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: 600,
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                          ],
                        },
                        // 4th item
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "text",
                              content: "✅",
                              styles: {
                                fontSize: "24px",
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                            {
                              id: generateId(),
                              type: "text",
                              content:
                                "Perfect for deeper results, sharing with loved ones, or avoiding backorders",
                              styles: {
                                color: "#231F20",
                                fontSize: "24px",
                                fontStyle: "normal",
                                fontWeight: 600,
                                lineHeight: "26px",
                              },
                              responsiveStyles: {
                                mobile: {
                                  fontSize: "18px",
                                  lineHeight: "24px",
                                },
                              },
                            },
                          ],
                        },
                      ],
                    },
                    // CTA Button
                    {
                      id: generateId(),
                      type: "button",
                      content: "YES Add 3 More Bottles for Just $87",
                      dynamicContentId: "__dynamic__button_offer__",
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0 35px",
                        height: "74px",
                        borderRadius: "14.568px",
                        border: "3.642px solid secondary",
                        backgroundImage:
                          "conic-gradient(from 72deg at 33.42% 100%, #F49D00 5.4deg, #FAC600 196.2deg, #FCC709 360deg)",
                        overflow: "hidden",
                        color: "#231F20",
                        textAlign: "center",
                        fontSize: "24px",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "100%",
                        fontFamily: "SF Pro Display",
                      },
                      responsiveStyles: {
                        tablet: {
                          alignSelf: "center",
                        },
                        mobile: {
                          fontSize: "16px",
                          height: "50px",
                        },
                      },
                    },
                    // Payment Methods Image
                    {
                      id: generateId(),
                      type: "image",
                      src: "/public/images/movyo/pay-option1.webp",
                      alt: "Payment Methods",
                      styles: {
                        maxWidth: "324px",
                        width: "100%",
                        objectFit: "contain",
                        margin: "8px 0 0 0",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        // Feature Box Text (Downsell Link)
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          },
          children: [
            {
              id: generateId(),
              type: "link",
              content: "No thanks,  I'll pass and risk losing my results later",
              href: "#",
              styles: {
                color: "#231F20",
                textAlign: "center",
                fontFamily: "SF Pro Display",
                fontSize: "30px",
                fontStyle: "italic",
                fontWeight: 300,
                lineHeight: "100%",
                textDecorationLine: "underline",
                textDecorationStyle: "solid",
                textDecorationSkipInk: "auto",
                textDecorationThickness: "auto",
                textUnderlineOffset: "auto",
                textUnderlinePosition: "from-font",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "16px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

// WHY YOU NEED THIS Section
export const template1UpsellWhyYouNeedSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    backgroundColor: "background",
    padding: "52px 0",
    textAlign: "center",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "40px 0",
    },
    mobile: {
      padding: "30px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxWidth: "1337px",
        padding: "0 20px",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px 0",
        },
        mobile: {
          gap: "20px 0",
        },
      },
      children: [
        // Title
        {
          id: generateId(),
          type: "text",
          content: "WHY YOU NEED THIS",
          styles: {
            color: "forground",
            fontSize: "58.3px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "100%",
            textAlign: "center",
            textTransform: "uppercase",
            marginBottom: "26px",
            fontFamily: "SF Pro Display",
          },
          responsiveStyles: {
            tablet: {
              fontSize: "32px",
            },
            mobile: {
              fontSize: "24px",
            },
          },
        },
        // Subtitle
        {
          id: generateId(),
          type: "text",
          content:
            "Most people who see real transformation use FortiGold for at least 90 days — and many go even longer.",
          styles: {
            fontFamily: "SF Pro Display",
            color: "forground",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "100%",
            textAlign: "center",
            marginBottom: "54px",
          },
          responsiveStyles: {
            tablet: {
              fontSize: "16px",
            },
            mobile: {
              fontSize: "14px",
            },
          },
        },
        // Benefits Container
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
          },
          responsiveStyles: {
            mobile: {
              gap: "16px",
            },
          },
          children: [
            {
              id: generateId(),
              type: "text",
              content: "By adding more bottles today, you:",
              styles: {
                color: "forground",
                fontSize: "28px",
                fontStyle: "normal",
                textAlign: "left",
                fontWeight: 700,
                lineHeight: "140%",
                marginBottom: "35px",
                fontFamily: "SF Pro Display",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "16px",
                },
              },
            },
            // Benefits List
            {
              id: generateId(),
              type: "container",
              styles: {
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                alignItems: "flex-start",
                textAlign: "left",
              },
              children: [
                // Benefit 1
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "6px",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "text",
                      content: "✅",
                      styles: {
                        fontSize: "18px",
                        lineHeight: "29.9px",
                        fontFamily: "Inter",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "Avoid the pain of running out just when results are kicking in",
                      styles: {
                        color: "forground",
                        fontSize: "28px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "100%",
                        fontFamily: "SF Pro Display",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                  ],
                },
                // Benefit 2
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "6px",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "text",
                      content: "✅",
                      styles: {
                        fontSize: "18px",
                        lineHeight: "29.9px",
                        fontFamily: "Inter",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "Lock in this one-time VIP pricing (you won't see $29/bottle again)",
                      styles: {
                        color: "forground",
                        fontSize: "28px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "100%",
                        fontFamily: "SF Pro Display",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                  ],
                },
                // Benefit 3
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "6px",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "text",
                      content: "✅",
                      styles: {
                        fontSize: "18px",
                        lineHeight: "29.9px",
                        fontFamily: "Inter",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "Get ahead of potential stock shortages or price hike",
                      styles: {
                        color: "forground",
                        fontSize: "28px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "100%",
                        fontFamily: "SF Pro Display",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// Thank You Doctor Section
export const template1UpsellThankYouDoctorSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    backgroundColor: "background",
    paddingBottom: "60px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "40px 0",
    },
    mobile: {
      padding: "30px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "40px 0",
        width: "100%",
        maxWidth: "1337px",
        padding: "0 20px",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px 0",
        },
        mobile: {
          gap: "20px 0",
        },
      },
      children: [
        // Title
        {
          id: generateId(),
          type: "text",
          content: "Thank you for ordering but...",
          styles: {
            color: "#000000",
            fontSize: "58.3px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "120%",
            textAlign: "center",
            marginBottom: "54px",
            fontFamily: "SF Pro Display",
          },
          responsiveStyles: {
            tablet: {
              fontSize: "28px",
            },
            mobile: {
              fontSize: "22px",
            },
          },
        },
        // Content Container with Doctor Image and Text
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            alignItems: "flex-start",
            gap: "49px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
              alignItems: "center",
              gap: "30px",
            },
            mobile: {
              gap: "20px",
            },
          },
          children: [
            // Doctor Image
            {
              id: generateId(),
              type: "image",
              src: "/fortigold/doctor.webp",
              alt: "Doctor",
              styles: {
                width: "400px",
                height: "500px",
                objectFit: "cover",
                flexShrink: 0,
              },
              responsiveStyles: {
                tablet: {
                  width: "180px",
                  height: "240px",
                },
                mobile: {
                  width: "140px",
                  height: "180px",
                },
              },
            },
            // Text Content
            {
              id: generateId(),
              type: "container",
              styles: {
                display: "flex",
                flexDirection: "column",
                flex: 1,
              },
              children: [
                {
                  id: generateId(),
                  type: "text",
                  content:
                    "Thank you for starting your journey with FortiGold — I'm truly excited. One bottle is a good start, but real change takes time. If FortiGold is going to change your life, you need more than 30 days to feel the progress truly begin. It's like hitting reset.",
                  styles: {
                    color: "forground",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "33.6px",
                    textAlign: "left",
                    fontFamily: "SF Pro Display",
                    marginBottom: "39px",
                  },
                  typography: "Body",
                  responsiveStyles: {
                    tablet: {
                      textAlign: "center",
                    },
                    mobile: {
                      fontSize: "14px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "text",
                  content:
                    "I've seen it too often — people feel better, run out, and their issues slowly come back. That's why I recommend at least 90 days to truly experience the progression your body is just starting to make.",
                  styles: {
                    color: "forground",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "33.6px",
                    textAlign: "left",
                    fontFamily: "SF Pro Display",
                    marginBottom: "39px",
                  },
                  typography: "Body",
                  responsiveStyles: {
                    tablet: {
                      textAlign: "center",
                    },
                    mobile: {
                      fontSize: "14px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "text",
                  content:
                    "Right now, you have a chance to lock in more bottles at the lowest price we'll ever offer you. If you can, grab them now — so you don't interrupt the progress your body is just starting to make.",
                  styles: {
                    color: "forground",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "33.6px",
                    textAlign: "left",
                    fontFamily: "SF Pro Display",
                    marginBottom: "36px",
                  },
                  typography: "Body",
                  responsiveStyles: {
                    tablet: {
                      textAlign: "center",
                    },
                    mobile: {
                      fontSize: "14px",
                    },
                  },
                },
                // Doctor Signature
                {
                  id: generateId(),
                  type: "text",
                  content: "Dr. James Mitchell",
                  styles: {
                    color: "forground",
                    fontSize: "42px",
                    fontStyle: "regular",
                    fontWeight: 400,
                    lineHeight: "130%",
                    textAlign: "left",
                    fontFamily: "Allura",
                  },
                  responsiveStyles: {
                    tablet: {
                      textAlign: "center",
                    },
                    mobile: {
                      fontSize: "16px",
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// Money Back Guarantee Section
export const template1UpsellMoneyBackGuaranteeSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    backgroundColor: "background",
    paddingTop: "60px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      padding: "40px 0",
    },
    mobile: {
      padding: "30px 0",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "0px",
        width: "100%",
      },
      children: [
        // Full Width Green Banner with Badge
        {
          id: generateId(),
          type: "container",
          styles: {
            backgroundImage:
              "linear-gradient(90deg, rgb(134, 156, 45) 10.18%, rgb(0, 87, 63) 42.91%, #00442A 72%, #00442A 80%)",
            width: "100%",
            padding: "20px 0",
            marginBottom: "40px",
            display: "flex",
            justifyContent: "center",
            position: "relative",
          },
          responsiveStyles: {
            tablet: {
              padding: "20px 0",
            },
            mobile: {
              padding: "16px 0",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container",
              styles: {
                maxWidth: "1200px",
                width: "100%",
                padding: "0 40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              },
              responsiveStyles: {
                tablet: {
                  padding: "0 20px",
                },
                mobile: {
                  padding: "0 20px",
                },
              },
              children: [
                // Text
                {
                  id: generateId(),
                  type: "text",
                  content: "PROTECTED BY 60 DAY 100% MONEY BACK GUARANTEE",
                  styles: {
                    color: "#FFF",
                    fontSize: "58.3px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "120%",
                    textAlign: "left",
                    fontFamily: "SF Pro Display",
                    paddingRight: "200px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                      paddingRight: "160px",
                    },
                    mobile: {
                      fontSize: "16px",
                      paddingRight: "120px",
                    },
                  },
                },
                // Money Back Badge - Positioned to extend beyond background
                {
                  id: generateId(),
                  type: "image",
                  src: "/fortigold/money-back.png",
                  alt: "100% Money Back Guarantee",
                  styles: {
                    width: "275px",
                    height: "264px",
                    objectFit: "contain",
                    position: "absolute",
                    right: "-60px",
                    top: "50%",
                    transform: "translateY(-50%) rotate(-8.4deg)",
                    zIndex: 2,
                  },
                  responsiveStyles: {
                    tablet: {
                      width: "220px",
                      height: "210px",
                      right: "-45px",
                    },
                    mobile: {
                      width: "180px",
                      height: "170px",
                      right: "-30px",
                    },
                  },
                },
              ],
            },
          ],
        },
        // Content Section with Max Width
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "42px",
            width: "100%",
            maxWidth: "1200px",
            textAlign: "center",
            margin: "0 auto",
          },
          children: [
            // Try It Risk-Free
            {
              id: generateId(),
              type: "text",
              content: "Try It Risk-Free for a Full 60 Days",
              styles: {
                color: "#000000",
                fontSize: "30px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "100%",
                textAlign: "center",
                fontFamily: "SF Pro Display",
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "18px",
                },
              },
            },
            // Main guarantee text
            {
              id: generateId(),
              type: "container",
              styles: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                width: "100%",
                textAlign: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "text",
                  content:
                    "We stand behind FortiGold 100%. That's why every bottle you order today is protected by our",
                  styles: {
                    color: "forground",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "100%",
                    textAlign: "center",
                    fontFamily: "SF Pro Display",
                  },
                  typography: "Body",
                  responsiveStyles: {
                    mobile: {
                      fontSize: "14px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "text",
                  content: "no-questions-asked 60 day guarantee.",
                  styles: {
                    color: "forground",
                    fontSize: "28px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "100%",
                    textAlign: "center",
                    fontFamily: "SF Pro Display",
                  },
                  responsiveStyles: {
                    mobile: {
                      fontSize: "14px",
                    },
                  },
                },
              ],
            },
            // Refund text
            {
              id: generateId(),
              type: "text",
              content:
                "If you don't feel a real difference - more energy, stronger digestion, better health overall - just let us know. You'll get a full refund, even if the bottles are empty.",
              styles: {
                color: "forground",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "100%",
                textAlign: "center",
                fontFamily: "SF Pro Display",
              },
              typography: "Body",
              responsiveStyles: {
                mobile: {
                  fontSize: "14px",
                },
              },
            },
            // No stress text
            {
              id: generateId(),
              type: "text",
              content: "No stress. No hassle.",
              styles: {
                color: "forground",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "100%",
                textAlign: "center",
                fontFamily: "SF Pro Display",
              },
              typography: "Body",
              responsiveStyles: {
                mobile: {
                  fontSize: "14px",
                },
              },
            },
            // Final question
            {
              id: generateId(),
              type: "text",
              content:
                "So why not give your body the time it needs to truly benefit?",
              styles: {
                color: "forground",
                fontSize: "28px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "100%",
                textAlign: "center",
                fontFamily: "SF Pro Display",
              },
              typography: "Body",
              responsiveStyles: {
                mobile: {
                  fontSize: "16px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

// Exclusive Bonuses Section
export const template1UpsellExclusiveBonusesSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    backgroundColor: "background",
    padding: "60px 0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "50px 0" },
    mobile: { padding: "40px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        margin: "0 auto",
        padding: "0 20px",
        width: "100%",
        maxWidth: "1216px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      children: [
        // Header
        {
          id: generateId(),
          type: "container",
          styles: {
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "108px",
            width: "100%",
            gap: "26px",
          },
          responsiveStyles: {
            tablet: { marginBottom: "40px" },
            mobile: { marginBottom: "30px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading",
              content: "Unlock Exclusive Bonuses – Yours FREE With Your Order",
              styles: {
                fontFamily: "SF Pro Display",
                fontWeight: 700,
                fontSize: "58.3px",
                lineHeight: "70px",
                color: "#000",
                maxWidth: "800px",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "32px",
                  lineHeight: "40px",
                  maxWidth: "400px",
                },
                mobile: {
                  fontSize: "24px",
                  lineHeight: "32px",
                  maxWidth: "300px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph",
              content:
                "<b>Get instant access</b> to these powerful guides designed to help you <b>boost energy, sharpen your mind, and optimize your health</b> — at no extra cost",
              styles: {
                fontFamily: "SF Pro Display",
                fontSize: "28px",
                lineHeight: "132%",
                color: "#000000",
                margin: "0 auto",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: { fontSize: "18px", lineHeight: "26px" },
                mobile: { fontSize: "16px", lineHeight: "24px" },
              },
            },
          ],
        },
        // Bonus Cards Container
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            justifyContent: "center",
            gap: "73px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            },
            mobile: {
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            },
          },
          children: [
            // Bonus Card 1 - Wake Up Energized
            {
              id: generateId(),
              type: "container",
              styles: {
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                overflow: "hidden",
                maxWidth: "384px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              },
              responsiveStyles: {
                mobile: {
                  maxWidth: "100%",
                },
              },
              children: [
                // Image
                {
                  id: generateId(),
                  type: "image",
                  src: "/template3/book1.png",
                  alt: "Wake Up Energized Bonus",
                  styles: {
                    width: "100%",
                    height: "461px",
                    objectFit: "cover",
                  },
                  responsiveStyles: {
                    mobile: { height: "250px" },
                  },
                },
                // Green Banner
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    backgroundImage:
                      "linear-gradient(89deg, primary 40.18%, #869C2D 102.91%)",
                    padding: "10px 15px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container",
                      styles: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        marginBottom: "5px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "text",
                          content: "Bonus #1",
                          styles: {
                            color: "#FFE927",
                            fontSize: "22.3px",
                            fontWeight: 700,
                            fontFamily: "SF Pro Display",
                          },
                          responsiveStyles: {
                            mobile: { fontSize: "16px" },
                          },
                        },
                        {
                          id: generateId(),
                          type: "text",
                          content: "- Wake Up Energized",
                          styles: {
                            color: "#fff",
                            fontSize: "22.3px",
                            fontWeight: 700,
                            fontFamily: "SF Pro Display",
                          },
                          responsiveStyles: {
                            mobile: { fontSize: "16px" },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "The revolutionary gut fix for mental fog & all-day focus",
                      styles: {
                        color: "#fff",
                        fontSize: "22.3px",
                        fontWeight: 700,
                        padding: "0 20px",
                        fontFamily: "SF Pro Display",
                        lineHeight: "26.87px",
                      },
                      responsiveStyles: {
                        mobile: { fontSize: "18px", lineHeight: "21px" },
                      },
                    },
                  ],
                },
                // Price Banner
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "18px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "text",
                      content: "$67",
                      styles: {
                        fontSize: "22.3px",
                        fontWeight: 700,
                        textDecoration: "line-through",
                        color: "#fff",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content: "Today:",
                      styles: {
                        fontSize: "22.3px",
                        fontWeight: 700,
                        color: "#8DC63F",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content: "FREE",
                      styles: {
                        fontSize: "22.3px",
                        fontWeight: 700,
                        color: "#fff",
                      },
                    },
                  ],
                },
                // Description
                {
                  id: generateId(),
                  type: "text",
                  content:
                    "Discover the 7-day morning reset that eliminates sluggishness and helps you start every day full of energy—without coffee crashes!",
                  styles: {
                    backgroundColor: "#F1F2F2",
                    fontFamily: "SF Pro Display",
                    fontSize: "20px",
                    lineHeight: "24px",
                    color: "#000000",
                    padding: "15px 25px",
                    textAlign: "center",
                    fontWeight: 300,
                  },
                },
              ],
            },
            // Bonus Card 2 - The Genius Code
            {
              id: generateId(),
              type: "container",
              styles: {
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
                overflow: "hidden",
                maxWidth: "384px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
              },
              responsiveStyles: {
                mobile: {
                  maxWidth: "100%",
                },
              },
              children: [
                // Image
                {
                  id: generateId(),
                  type: "image",
                  src: "/template3/book2.png",
                  alt: "The Genius Code Bonus",
                  styles: {
                    width: "100%",
                    height: "461px",
                    objectFit: "cover",
                  },
                  responsiveStyles: {
                    mobile: { height: "250px" },
                  },
                },
                // Green Banner
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    backgroundImage:
                      "linear-gradient(89deg, primary 40.18%, #869C2D 102.91%)",
                    padding: "10px 15px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container",
                      styles: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        marginBottom: "5px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "text",
                          content: "Bonus #2",
                          styles: {
                            color: "#FFE927",
                            fontSize: "22.3px",
                            fontWeight: 700,
                            fontFamily: "SF Pro Display",
                          },
                          responsiveStyles: {
                            mobile: { fontSize: "16px" },
                          },
                        },
                        {
                          id: generateId(),
                          type: "text",
                          content: "- The Genius Code",
                          styles: {
                            color: "#fff",
                            fontSize: "22.3px",
                            fontWeight: 700,
                            fontFamily: "SF Pro Display",
                          },
                          responsiveStyles: {
                            mobile: { fontSize: "16px" },
                          },
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "Created with famous brain expert Dr. Reynolds Eichmann.",
                      styles: {
                        color: "#fff",
                        fontSize: "22.3px",
                        fontWeight: 700,
                        padding: "0 20px",
                        fontFamily: "SF Pro Display",
                        lineHeight: "26.87px",
                      },
                      responsiveStyles: {
                        mobile: { fontSize: "18px", lineHeight: "21px" },
                      },
                    },
                  ],
                },
                // Price Banner
                {
                  id: generateId(),
                  type: "container",
                  styles: {
                    backgroundColor: "#000",
                    color: "#fff",
                    padding: "18px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "text",
                      content: "$47",
                      styles: {
                        fontSize: "22.3px",
                        fontWeight: 700,
                        textDecoration: "line-through",
                        color: "#fff",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content: "Today:",
                      styles: {
                        fontSize: "22.3px",
                        fontWeight: 700,
                        color: "#8DC63F",
                      },
                    },
                    {
                      id: generateId(),
                      type: "text",
                      content: "FREE",
                      styles: {
                        fontSize: "22.3px",
                        fontWeight: 700,
                        color: "#fff",
                      },
                    },
                  ],
                },
                // Description
                {
                  id: generateId(),
                  type: "text",
                  content:
                    "These are the same techniques that world's memory champions use but have never been revealed to the public. Until now, it transforms full potential.",
                  styles: {
                    backgroundColor: "#F1F2F2",
                    fontFamily: "SF Pro Display",
                    fontSize: "20px",
                    lineHeight: "24px",
                    color: "#000000",
                    padding: "15px 25px",
                    fontWeight: 300,
                    textAlign: "center",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// Testimonials Section
export const template1UpsellTestimonialsSection = (
  globalConfig: GlobalConfig
) => ({
  id: generateId(),
  type: "container",
  styles: {
    backgroundColor: "background",
    color: "forground",
    padding: "104px 0",
    width: "100%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    mobile: { padding: "40px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container",
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 15px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      responsiveStyles: {
        tablet: { padding: "0" },
        mobile: { padding: "0" },
      },
      children: [
        // Header Section (Main Title)
        {
          id: generateId(),
          type: "container",
          styles: {
            textAlign: "center",
            marginBottom: "60px",
          },
          responsiveStyles: {
            tablet: { marginBottom: "30px", padding: "0 20px" },
            mobile: { marginBottom: "39px", padding: "0 20px" },
          },
          children: [
            {
              id: generateId(),
              type: "heading",
              content: "JOIN COUNTLESS OTHERS WHO STACKED UP",
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "64px",
                lineHeight: "72px",
                marginBottom: "24px",
                letterSpacing: "-1.92px",
                color: "forground",
                opacity: "0.9",
              },
              responsiveStyles: {
                tablet: { fontSize: "40px" },
                mobile: {
                  fontSize: "38px",
                  lineHeight: "48px",
                  letterSpacing: "-1.14px",
                  marginBottom: "16px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph",
              content:
                "<b>Countless happy users</b> have already gone all in with FortiGold.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "28px",
                fontWeight: 400,
                letterSpacing: "-0.28px",
                color: "forground",
                margin: 0,
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "22px",
                  lineHeight: "28px ",
                  letterSpacing: "-0.22px",
                },
              },
            },
          ],
        },
        // Customer Say + Stars + Review Count
        {
          id: generateId(),
          type: "container",
          styles: {
            textAlign: "center",
            marginBottom: "104px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "50px",
          },
          responsiveStyles: {
            tablet: { marginBottom: "60px", gap: "25px", padding: "0 20px" },
            mobile: { marginBottom: "39px", gap: "18px", padding: "0 20px" },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph",
              content: "Our Customer say",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "28px",
                color: "forground",
                opacity: "0.6",
                margin: 0,
              },
              responsiveStyles: {
                mobile: {
                  fontSize: "18px",
                  lineHeight: "28px",
                  letterSpacing: "-0.18px",
                },
              },
            },
            // 5 Star Rating Badge
            {
              id: generateId(),
              type: "container",
              styles: {
                backgroundColor: "#FFB800",
                padding: "8px 16px",
                borderRadius: "6px",
                display: "inline-block",
              },
              children: [
                {
                  id: generateId(),
                  type: "text",
                  content: "5 STAR RATING",
                  styles: {
                    color: "#000",
                    fontSize: "14px",
                    fontWeight: 700,
                    fontFamily: "SF Pro Display",
                    fontStyle: "italic",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "image",
              src: "/fortigold/5-star-rating.png",
              alt: "5-star reviews",
              styles: {
                width: "714px",
                maxWidth: "100%",
                height: "auto",
                display: "flex",
                justifyContent: "center",
                margin: 0,
              },
            },
            {
              id: generateId(),
              type: "paragraph",
              content:
                '<span style="color:' +
                "forground" +
                ';font-weight:900;">Countless Five-Star Reviews</span> and Growing',
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontSize: "40px",
                letterSpacing: "-0.4px",
                color: "forground",
                opacity: "0.6",
                margin: 0,
              },
              responsiveStyles: {
                tablet: { fontSize: "28px" },
                mobile: {
                  fontSize: "22px",
                  lineHeight: "28px",
                  letterSpacing: "-0.22px",
                },
              },
            },
          ],
        },
        // Gallery Images
        {
          id: generateId(),
          type: "container",
          styles: {
            marginBottom: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: { marginBottom: "30px", gap: "20px" },
            mobile: {
              marginBottom: "30px",
              gap: "20px",
              flexDirection: "column",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image",
              src: "/fortigold/testimonials1.png",
              alt: "Happy customer with FortiGold",
              styles: {
                width: "258px",
                height: "324px",
                borderRadius: "12px",
                objectFit: "cover",
                boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                transform: "rotate(-8deg)",
              },
              responsiveStyles: {
                tablet: {
                  width: "200px",
                  height: "250px",
                  transform: "rotate(-5deg)",
                },
                mobile: {
                  width: "180px",
                  height: "220px",
                  transform: "rotate(0deg)",
                },
              },
            },
            {
              id: generateId(),
              type: "image",
              src: "/fortigold/testimonials1.png",
              alt: "Another happy customer with FortiGold",
              styles: {
                width: "258px",
                height: "324px",
                borderRadius: "12px",
                objectFit: "cover",
                boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                transform: "rotate(8deg)",
              },
              responsiveStyles: {
                tablet: {
                  width: "200px",
                  height: "250px",
                  transform: "rotate(5deg)",
                },
                mobile: {
                  width: "180px",
                  height: "220px",
                  transform: "rotate(0deg)",
                },
              },
            },
          ],
        },
        // Testimonials
        {
          id: generateId(),
          type: "container",
          styles: {
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            maxWidth: "800px",
            margin: "0 auto",
            width: "100%",
          },
          responsiveStyles: {
            mobile: {
              gap: "20px",
            },
          },
          children: [
            // Testimonial 1
            {
              id: generateId(),
              type: "container",
              styles: {
                background: "#fff",
                borderRadius: "16px",
                padding: "20px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                display: "flex",
                gap: "20px",
                alignItems: "flex-start",
              },
              responsiveStyles: {
                mobile: {
                  gap: "15px",
                  padding: "16px",
                },
              },
              children: [
                // Avatar
                {
                  id: generateId(),
                  type: "image",
                  src: "/fortigold/user_testimonial.png",
                  alt: "Sasha L.",
                  styles: {
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                  },
                  responsiveStyles: {
                    mobile: {
                      width: "60px",
                      height: "60px",
                    },
                  },
                },
                // Content
                {
                  id: generateId(),
                  type: "container",
                  styles: { flex: 1 },
                  children: [
                    // Review text
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "I used to deal with brain fog and bad breath that made me feel embarrassed. Now I can think clearly, my focus and my good mood impact every day!",
                      styles: {
                        fontFamily: "SF Pro Display",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#333",
                        marginBottom: "15px",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                          lineHeight: "20px",
                        },
                      },
                    },
                    // Stars and name
                    {
                      id: generateId(),
                      type: "container",
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                      },
                      children: [
                        // Stars
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            gap: "2px",
                          },
                          children: Array(5)
                            .fill(null)
                            .map(() => ({
                              id: generateId(),
                              type: "text",
                              content: "⭐",
                              styles: {
                                fontSize: "16px",
                              },
                            })),
                        },
                        {
                          id: generateId(),
                          type: "text",
                          content: "Happy Customer",
                          styles: {
                            fontSize: "14px",
                            color: "#FFB800",
                            fontWeight: 600,
                            fontFamily: "SF Pro Display",
                          },
                        },
                      ],
                    },
                    // Name
                    {
                      id: generateId(),
                      type: "text",
                      content: "Sasha L., 35",
                      styles: {
                        fontFamily: "SF Pro Display",
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#000",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                  ],
                },
              ],
            },
            // Testimonial 2
            {
              id: generateId(),
              type: "container",
              styles: {
                background: "#fff",
                borderRadius: "16px",
                padding: "20px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                display: "flex",
                gap: "20px",
                alignItems: "flex-start",
              },
              responsiveStyles: {
                mobile: {
                  gap: "15px",
                  padding: "16px",
                },
              },
              children: [
                // Avatar
                {
                  id: generateId(),
                  type: "image",
                  src: "/fortigold/user_testimonial.png",
                  alt: "Jason M.",
                  styles: {
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                  },
                  responsiveStyles: {
                    mobile: {
                      width: "60px",
                      height: "60px",
                    },
                  },
                },
                // Content
                {
                  id: generateId(),
                  type: "container",
                  styles: { flex: 1 },
                  children: [
                    // Review text
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "I used to laugh names at the time, which wasn't great for my work. Ever since I started using FortiGold, my memory is sharper and my gains feel much too!",
                      styles: {
                        fontFamily: "SF Pro Display",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#333",
                        marginBottom: "15px",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                          lineHeight: "20px",
                        },
                      },
                    },
                    // Stars and name
                    {
                      id: generateId(),
                      type: "container",
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                      },
                      children: [
                        // Stars
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            gap: "2px",
                          },
                          children: Array(5)
                            .fill(null)
                            .map(() => ({
                              id: generateId(),
                              type: "text",
                              content: "⭐",
                              styles: {
                                fontSize: "16px",
                              },
                            })),
                        },
                        {
                          id: generateId(),
                          type: "text",
                          content: "Happy Customer",
                          styles: {
                            fontSize: "14px",
                            color: "#FFB800",
                            fontWeight: 600,
                            fontFamily: "SF Pro Display",
                          },
                        },
                      ],
                    },
                    // Name
                    {
                      id: generateId(),
                      type: "text",
                      content: "Jason M., 52",
                      styles: {
                        fontFamily: "SF Pro Display",
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#000",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                  ],
                },
              ],
            },
            // Testimonial 3
            {
              id: generateId(),
              type: "container",
              styles: {
                background: "#fff",
                borderRadius: "16px",
                padding: "20px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                display: "flex",
                gap: "20px",
                alignItems: "flex-start",
              },
              responsiveStyles: {
                mobile: {
                  gap: "15px",
                  padding: "16px",
                },
              },
              children: [
                // Avatar
                {
                  id: generateId(),
                  type: "image",
                  src: "/fortigold/user_testimonial.png",
                  alt: "Michelle T.",
                  styles: {
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                  },
                  responsiveStyles: {
                    mobile: {
                      width: "60px",
                      height: "60px",
                    },
                  },
                },
                // Content
                {
                  id: generateId(),
                  type: "container",
                  styles: { flex: 1 },
                  children: [
                    // Review text
                    {
                      id: generateId(),
                      type: "text",
                      content:
                        "I was scared of being my memory like my dad. But after using FortiGold I think more clearly, I have way more energy and my mental edges feel sharp all day.",
                      styles: {
                        fontFamily: "SF Pro Display",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#333",
                        marginBottom: "15px",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                          lineHeight: "20px",
                        },
                      },
                    },
                    // Stars and name
                    {
                      id: generateId(),
                      type: "container",
                      styles: {
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                      },
                      children: [
                        // Stars
                        {
                          id: generateId(),
                          type: "container",
                          styles: {
                            display: "flex",
                            gap: "2px",
                          },
                          children: Array(5)
                            .fill(null)
                            .map(() => ({
                              id: generateId(),
                              type: "text",
                              content: "⭐",
                              styles: {
                                fontSize: "16px",
                              },
                            })),
                        },
                        {
                          id: generateId(),
                          type: "text",
                          content: "Happy Customer",
                          styles: {
                            fontSize: "14px",
                            color: "#FFB800",
                            fontWeight: 600,
                            fontFamily: "SF Pro Display",
                          },
                        },
                      ],
                    },
                    // Name
                    {
                      id: generateId(),
                      type: "text",
                      content: "Michelle T., 47",
                      styles: {
                        fontFamily: "SF Pro Display",
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#000",
                      },
                      responsiveStyles: {
                        mobile: {
                          fontSize: "14px",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

// Limited Supply Section (from template1)
const createFortigoldLimitedSupplySection = (
  globalConfig: GlobalConfig,
  vslShowHide?: boolean
) => ({
  id: generateId(),
  type: "container" as ElementType,
  vslShowHide: vslShowHide,
  styles: {
    backgroundColor: "#005740",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: { padding: "20px" },
    mobile: { padding: "13px 16px" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1500px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "40px",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "column",
          textAlign: "center",
          gap: "25px",
        },
        mobile: {
          flexDirection: "column",
          textAlign: "center",
          gap: "0px",
          maxWidth: "100%",
        },
      },
      children: [
        // Badge
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "360px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "transparent",
              },
              responsiveStyles: {
                tablet: { width: "200px", height: "200px" },
                mobile: { width: "239px", height: "236px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/img_guranteed.png",
                  alt: "Genuine Product Badge",
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                  responsiveStyles: {
                    tablet: { width: "200px", height: "200px" },
                    mobile: { width: "239px", height: "236px" },
                  },
                },
              ],
            },
          ],
        },
        // Text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            color: globalConfig.colors.secondary || "#fff",
            maxWidth: "1055px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: `<span style="text-decoration:underline;color:${
                globalConfig.colors.secondary || "#fff"
              };">Limited Supply Available</span> – <span style="color:#fcbc03;text-decoration:none;">Selling Out Fast!</span>`,
              styles: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 900,
                fontSize: "54px",
                lineHeight: "72px",
                textAlign: "center",
                letterSpacing: "-0.54px",
                marginBottom: "12px",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "32px",
                  lineHeight: "42px",
                  marginBottom: "12px",
                },
                mobile: {
                  fontSize: "27px",
                  lineHeight: "40px",
                  letterSpacing: "-0.27px",
                  marginBottom: "12px",
                },
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Due to high demand, FORTIGOLD is selling out faster than expected. Once this batch is gone, restocking could take months.",
              styles: {
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: "28px",
                lineHeight: "40px",
                textAlign: "center",
                letterSpacing: "-0.28px",
                margin: 0,
              },
              responsiveStyles: {
                tablet: { fontSize: "22px", lineHeight: "32px" },
                mobile: {
                  fontSize: "18px",
                  lineHeight: "32px",
                  letterSpacing: "-0.18px",
                  marginBottom: "32px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

// Scientific References Section (from template1)
const createScientificReferencesSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "100px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "72px 0 36px 0" },
    mobile: { padding: "40px 0 32px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px" },
        mobile: { gap: "12px" },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Scientific References:",
          styles: {
            color: "forground",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "34px",
            fontWeight: 400,
            lineHeight: "80px",
            letterSpacing: "-1.35px",
            margin: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          responsiveStyles: {
            mobile: { fontSize: "22px", lineHeight: "25px" },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "35px",
            height: "100px",
          },
          responsiveStyles: {
            tablet: { gap: "24px", height: "auto" },
            mobile: { gap: "20px", height: "auto" },
          },
          children: [
            ...[1, 2, 3, 4].map((i) => ({
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: "258px",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { maxWidth: "220px" },
                mobile: { maxWidth: "167px" },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/fortigold/scientificReferencesSection1.png",
                  alt: `Reference Logo ${i}`,
                  styles: {
                    width: "100%",
                    objectFit: "contain",
                  },
                },
              ],
            })),
          ],
        },
      ],
    },
  ],
});

// Scientific Reference Listing Section (from template1)
const createScientificRefListingSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "60px 0 72px 0",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: { padding: "32px 0" },
    mobile: { padding: "24px 0" },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1334px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "0px",
      },
      responsiveStyles: {
        tablet: { gap: "18px", maxWidth: "95%" },
        mobile: { gap: "12px", maxWidth: "95%" },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "24px",
          },
          responsiveStyles: {
            tablet: { gap: "18px", flexDirection: "column" },
            mobile: { gap: "12px", flexDirection: "column" },
          },
          children: [
            // First Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                ...[1, 2, 3, 4].map((i) => ({
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                })),
              ],
            },
            // Second Col
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "calc(50% - 12px)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "16px",
              },
              responsiveStyles: {
                tablet: { width: "100%" },
                mobile: { width: "100%" },
              },
              children: [
                ...[1, 2, 3, 4].map((i) => ({
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "inline",
                    width: "100%",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: `<b>Campos, M.</b> (2022). Leaky Gut: What is it and What Does it Mean for Your Health? Harvard Health Blog. Retrieved from <a href='https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451' target='_blank' style='text-decoration: underline; color: ${
                        globalConfig.colors.link || "rgba(0, 0, 0, 0.70)"
                      };'>https://www.health.harvard.edu/blog/leaky-gut-what-is-it-and-what-does-it-mean-for-you-2017092212451</a>`,
                      styles: {
                        color: "forground",
                        opacity: "0.7",
                        fontSize: "18px",
                        fontFamily: "Poppins, sans-serif",
                        margin: 0,
                      },
                    },
                  ],
                })),
              ],
            },
          ],
        },
      ],
    },
  ],
});

// Footer Menu Section (from template1)
const createFooterMenuSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "primary",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "100%",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            height: "100px",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "0 72px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              gap: "0 24px",
            },
            mobile: {
              flexDirection: "column",
              gap: "28px 16px",
              height: "auto",
              padding: "28px 0",
            },
          },
          children: [
            // Privacy
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Privacy",
              href: "/privacy-policy",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Terms & Conditions
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Terms & Conditions",
              href: "/terms-and-conditions",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Disclaimer
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Disclaimer",
              href: "/disclaimer",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Product Label (trigger, not a link)
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "Product Label",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
                cursor: "pointer",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
              triggerPopup: "fortigold-label-popup",
              // You can add a custom property for JS trigger if needed
            },
            // Returns & Refunds
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Returns & Refunds",
              href: "/returns-and-refunds",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
            // Contact
            {
              id: generateId(),
              type: "link" as ElementType,
              content: "Contact",
              href: "/contact-us",
              styles: {
                color: "background",
                textAlign: "center",
                fontFamily: "Roboto, sans-serif",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 900,
                letterSpacing: "-1.05px",
                transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none",
                display: "block",
              },
              hoverStyles: {
                transform: "translateY(-5px)",
              },
              responsiveStyles: {
                mobile: {
                  fontWeight: 700,
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

// Footer End Section (from template1)
const createFooterEndSection = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "background",
    margin: 0,
    padding: 0,
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        maxWidth: "1200px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "12px",
        padding: "60px 0 0",
      },
      responsiveStyles: {
        mobile: {
          padding: "0 15px",
          margin: "30px auto 0",
        },
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease. The information presented on this site is for informational purposes only and is not a substitute for advice from your physician or other healthcare professional. Always consult with a qualified healthcare provider before beginning any diet, supplement, or exercise program.",
          styles: {
            textAlign: "center",
            color: "forground",
            opacity: "0.6",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Individual results may vary. Testimonials and reviews appearing on this site reflect real-life experiences of individuals who used our products. However, results may not be typical and are not guaranteed.",
          styles: {
            textAlign: "center",
            color: "forground",
            opacity: "0.6",
            fontFamily: "Poppins, sans-serif",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "-0.28px",
          },
          responsiveStyles: {
            mobile: {
              fontSize: "16px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Copyright © 2024 – 2025 FortiGold. All Rights Reserved.",
          styles: {
            padding: "30px 0",
            color: "forground",
            opacity: "0.6",
            textAlign: "center",
            fontFamily: "Poppins, sans-serif",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "45px",
            letterSpacing: "-0.22px",
          },
          responsiveStyles: {
            tablet: {
              padding: "10px 0",
              fontSize: "12px",
            },
            mobile: {
              padding: "10px 0",
              fontSize: "12px",
            },
          },
        },
      ],
    },
  ],
});

export const template1Upsell = (globalConfig: GlobalConfig) => {
  return {
    headerAlertMsg: headerAlertMsgContainer(globalConfig),
    upsellHeaderSection: createUpsellHeaderSectionContainer(globalConfig),
    offerSubHeaderSection: template1UpsellOfferSubHeaderSection(globalConfig),
    featuresBoxSection: template1UpsellFeaturesBoxSection(globalConfig),
    whyYouNeedSection: template1UpsellWhyYouNeedSection(globalConfig),
    thankYouDoctorSection: template1UpsellThankYouDoctorSection(globalConfig),
    moneyBackGuaranteeSection:
      template1UpsellMoneyBackGuaranteeSection(globalConfig),
    finalOfferSection: template1UpsellFeaturesBoxSection(globalConfig), // Reusing the same features box
    exclusiveBonusesSection:
      template1UpsellExclusiveBonusesSection(globalConfig),
    testimonialsSection: template1UpsellTestimonialsSection(globalConfig),
    limitedSupplySection: createFortigoldLimitedSupplySection(globalConfig),
    finalFeaturesSection: template1UpsellFeaturesBoxSection(globalConfig),
    scientificReferencesSection:
      createScientificReferencesSection(globalConfig),
    scientificRefListingSection:
      createScientificRefListingSection(globalConfig),
    footerMenuSection: createFooterMenuSection(globalConfig),
    footerEndSection: createFooterEndSection(globalConfig),
  };
};
